export const indicator = {
  availableOnMobile: "Disponible sur mobile",
  schedulingIssue: {
    1: "Erreur de planification (date planifiée postérieure au délai d'intervention)",
    2: "Retard (Date planifiée antérieure à aujourd'hui)",
    4: "Délai d'intervention expiré",
  },
  schedulingIssueLabel: {
    1: "Erreur",
    2: "Retard",
    4: "Expiré",
  },
  withoutTemplate: "Aucun gabarit associé",
  assetExceededLifespan: "Durée de vie dépassée",
};
